// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import PackageJson from "../../package.json"
import {type Environment} from "@environment/types"

/**
 * Configuration for preview deployments (i.e. all deployments to non-prod environments).
 */
export const environment: Environment = {
    production: true,
    name: "qa2",
    version: PackageJson.version,

    auth: {
        google: {
            clientId: "608675176242-9a7778mmllu4026o5m3ehi2n58vir03n.apps.googleusercontent.com",
        },
        microsoft: {
            clientId: "151d8cd7-eff9-441e-b8b9-1072287949cb",
        },
    },

    firebase: {
        apiKey: "AIzaSyBkkhqjkc9Q0RnAs9Gqf6WRxY4jg8Uct_E",
        authDomain: "cm-platform-qa2.firebaseapp.com",
        projectId: "cm-platform-qa2",
        storageBucket: "cm-platform-qa2.firebasestorage.app",
        messagingSenderId: "32550988919",
        appId: "1:32550988919:web:01a39900b49621460b2a72",
    },
    firebaseConfig: {
        collectionEnabled: true,
    },

    rendering: {
        materialAssets: {
            fallbackTemplateId: 17484,
            samples: 64,
        },
        shaderBall: {
            templateId: 17482,
        },
        defaultQueueDomain: "colormass",
        maxConcurrentRenderJobs: 200,
    },

    storage: {
        bucketsPrefix: "cm-platform-qa2-",
        usePostToUpload: false,
    },

    style: {
        application: {
            background: "#991b1b40",
            label: "qa2",
        },
    },

    debug: {
        enableCallStack: false,
    },

    onboarding: {
        allowSkipPayment: false,
    },

    stripe: {
        fullyIntegrated: false,
    },

    configuratorUrl: "https://configurator-qa2.colormass.com?apiVersion=2",
    platformDeployUrl: "https://qa2.colormass.com",
    configuratorDeployUrl: "https://configurator-qa2.colormass.com",
    gqlApiEndpoint: "https://gql-qa2.colormass.com",
    jobsInstanceUrl: "https://jobs-qa2.colormass.com",
    localTilingEndpoint: "ws://localhost:5678/",

    defaultRenderQueueDomain: "render",
}
